export function checkIsString(input: unknown): input is string {
  return typeof input === "string";
}

export function parseUnknownToString(input: unknown): string | null {
  if (typeof input === "string") {
    return input;
  }

  if (typeof input === "number") {
    return `${input}`;
  }

  return null;
}
